import { Box, Grid, TextField } from '@mui/material';
import * as React from 'react';
import * as Redux from 'react-redux';
import * as CONST from '../../../../constants/FieldsConst';
import { validMessage } from '../../../../constants/ValidsFormConst';
import { useNotification } from '../../../../helpers/Notification';
import { LoadingWidget } from '../../../../widgets';
import AlertWidget from '../../../../widgets/AlertMsg';
import SelectFieldSeccionesComponent from '../../../control_estudios/secciones/components/SelectFieldSecciones';
import BotonComponent from '../../../dashboard/components/BotonNuevo';
import { allUsuEntidadesService } from '../../../usuario/usu_entidades/UsuEntidadesService';
import CardEstudianteComponent from '../../boletines/components/CardEstudiante';
import { saveMatriculasAction } from '../MatriculasAction';

const FormMatriculas = ({ setOpenModalForm }) => {
  const dispatch = Redux.useDispatch();
  const { notify } = useNotification();

  const entidadesStore = Redux.useSelector((state) => state.entidades);
  const matriculasStore = Redux.useSelector((state) => state.matriculas);

  const activo = matriculasStore.activo;

  const initData = {
    nroRegistro: '',
    idSeccion: '',
    idEstatus: 1,
  };

  const [data, setData] = React.useState(initData);
  const [dataError, setDataRequired] = React.useState({
    nroRegistro: false,
    idEstatus: false,
  });
  const [loadingSave, setLoadingSave] = React.useState(false);

  const [estudianteSelect, setEstudianteSelect] = React.useState(null);

  const [queryBuscar, setQueryBuscar] = React.useState(null);
  const [loadingBuscar, setLoadingBuscar] = React.useState(false);
  const [notData, setNotData] = React.useState(false);

  React.useEffect(() => {
    if (!activo) return;
    let values = {};
    Object.keys(data).map((key) => (values[key] = activo[key]));
    setTimeout(() => {
      const seccion = activo.secciones.find((sec) => !sec.aprobado)?.seccion;
      setData({
        ...values,
        idSeccion: seccion?.id,
        idEstatus: activo.estatus.id,
      });
      setEstudianteSelect(activo.estudiante);
    }, 300);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [activo]);

  const _handleSetDataField = (key, value) =>
    setData({ ...data, [key]: value });

  const _validDataForm = () => {
    let r = {};
    let va = [];
    Object.keys(dataError).map((key) => {
      const val = data[key];
      const valid = !val || val === '' || val === 0;
      r[key] = valid;
      return va.push(valid);
    });
    setDataRequired(r);
    return !va.includes(true);
  };

  const _handleSubmit = async () => {
    if (!entidadesStore.activo) {
      notify('Falta seleccionar la entidad', { warning: true });
      return;
    }

    if (!estudianteSelect) {
      notify('Falta seleccionar un estudiante', { warning: true });
      return;
    }

    if (_validDataForm()) {
      setLoadingSave(true);
      let res = await saveMatriculasAction(
        { dispatch, notify },
        activo?.id,
        {
          ...data,
          idEntidad: entidadesStore.activo.id,
          idEstudiante: estudianteSelect.usuario.id,
        },
        matriculasStore.params,
      );
      if (res) setOpenModalForm(false);
      setLoadingSave(false);
    }
  };

  React.useEffect(() => {
    async function fetchData() {
      if (!queryBuscar || queryBuscar === '') return;

      setNotData(false);
      setEstudianteSelect(null);
      setLoadingBuscar(true);

      let timer;

      timer = setTimeout(async () => {
        const res = await allUsuEntidadesService({
          idEntidad: entidadesStore.activo.id,
          q: queryBuscar,
        });

        if (res.data.data.length === 1) {
          setEstudianteSelect(res.data.data[0]);
        } else {
          setNotData(true);
          setTimeout(() => setNotData(false), 4000);
        }

        setLoadingBuscar(false);
      }, 1500);

      if (timer) {
        return () => clearTimeout(timer);
      }
    }
    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [queryBuscar]);

  return (
    <Box component="form">
      <Grid container spacing={2}>
        {loadingSave && (
          <Grid item xs={12} md={12}>
            <LoadingWidget isLoading={loadingSave} isActivo={activo} />
          </Grid>
        )}
        <Grid item xs={12} md={12}>
          <TextField
            fullWidth
            size="small"
            id={CONST.nroRegistro.name}
            label={CONST.nroRegistro.label}
            value={data.nroRegistro}
            required
            onChange={(e) =>
              _handleSetDataField(CONST.nroRegistro.name, e.target.value)
            }
            helperText={dataError.nroRegistro ? validMessage.required : null}
            error={dataError.nroRegistro}
          />
        </Grid>
        <Grid item xs={12} md={12}>
          <SelectFieldSeccionesComponent
            value={data.idSeccion}
            isAll={false}
            onChange={(idSeccion) => {
              _handleSetDataField(CONST.seccion.idName, idSeccion);
            }}
          />
        </Grid>
        {!activo && (
          <>
            <Grid item xs={12} md={12}>
              <TextField
                fullWidth
                size="small"
                id={CONST.dni.name}
                required
                label={`${CONST.dni.label} del estudiante`}
                value={queryBuscar}
                onChange={(e) => setQueryBuscar(e.target.value)}
                helperText={dataError.dni ? validMessage.required : null}
                error={dataError.dni}
              />
              <LoadingWidget
                isLoading={loadingBuscar}
                text="Consultando estudiante..."
              />
              {notData && (
                <AlertWidget
                  alert={{
                    severity: 'error',
                    title: 'No se encontraron resultados',
                  }}
                />
              )}
            </Grid>
            {estudianteSelect && (
              <Grid item xs={12} md={12}>
                <CardEstudianteComponent data={estudianteSelect} />
              </Grid>
            )}
          </>
        )}
        <Grid item xs={12} md={12} align="center">
          <BotonComponent
            click={_handleSubmit}
            disabled={loadingSave}
            text={activo ? 'ACTUALIZAR' : 'GUARDAR'}
            green={!activo}
            blue={activo}
            saveIcon
          />
        </Grid>
      </Grid>
    </Box>
  );
};

export default FormMatriculas;
